import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import './newProfile.less';
import '../style.less';

import { ArrowWoTail, LogoutIcon } from '../../../../components/icon';
import Button from 'antd/es/button';
import { PhoneOutlined } from '@ant-design/icons';
import { GetUserFilesNow } from '../../action/util_actions';
import { deleteRegisterNotificationToken } from '../../../distributor/action/util_action';
import { logoutAction } from '../../action';
import { trackUserLogout } from '../../../../utils/clevertap';

/*
import Select from "antd/es/select";
*/

const availableLanguages = {
  en: 'English',
  hi: 'Hindi - हिंदी',
};
let keys = Object.keys(availableLanguages);

export const rightArrowPanelIcon = () => (
  <ArrowWoTail
    onClick={(event) => {
      event.stopPropagation();
    }}
  />
);

const StickyTop = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selectedLanguage, setSelectedLanguage] = useState('en_state');
  const { loginUser } = useSelector((state) => {
    return {
      loginUser: state.loginReducer.loginUser,
    };
  });
  useEffect(() => {
    if (!loginUser) {
      navigate('/login', { replace: true });
      return;
    }
  }, [loginUser]);

  const { firstname, lastname, phone_number, company_details } = !loginUser
    ? {}
    : loginUser;

  const [userImage, setUserImage] = useState(null);

  const setImageFunc = async () => {
    const imageUrl = await GetUserFilesNow(loginUser.id, 8);
    setUserImage(imageUrl);
  };
  //
  useEffect(() => {
    setImageFunc();
    setLang();
  }, []);

  const setLang = () => {
    let lang = localStorage.getItem('language');
    if (lang) {
      setSelectedLanguage(lang);
    }
  };

  let compDetails = null;
  let district = null;

  if (company_details) {
    compDetails = company_details;
    let { district_id } = company_details;
    if (district_id) {
      district = district_id;
    }
  }
  const dispatch = useDispatch();

  return (
    <div
      style={{
        backgroundColor: '#F49D3F',
      }}
      className='top-row'
    >
      <div
        style={{
          flex: '1',
        }}
        className={'text'}
      >
        HUMBEE
      </div>
      <div
        style={{
          flex: '1',
        }}
        className={'profile-button-container'}
      >
        <div className={'profileCard profile-button-card'}>
          <a href='tel:+18002100123'>
            <Button
              block={true}
              className={'skip-Btn buttonLogOut'}
              type='primary'
              style={{
                width: '100%',
                height: '100%',
                backgroundColor: 'white',
              }}
            >
              <PhoneOutlined
                style={{ fontSize: '25px', fontWeight: 900, color: '#F49D3F' }}
              />
              <b
                style={{
                  color: '#F49D3F',
                }}
                className={'btn-text'}
              >
                {t('profile.contactUs')}
              </b>
            </Button>
          </a>
        </div>
        <div className={'profileCard profile-button-card'}>
          <Button
            onClick={async (e) => {
              try {
                // Track logout in CleverTap before clearing data
                await trackUserLogout();
              } catch (error) {
                // Silent fail
              }
              
              const userToken = JSON.parse(
                localStorage.getItem('message_token'),
              );
              // console.log("userToken", userToken);
              deleteRegisterNotificationToken(userToken);
              logoutAction();
              localStorage.clear();
              dispatch({ type: 'LOGOUT' });
              // .then((res) => {
              //   if (!res.error) {
              //     localStorage.clear();
              //     dispatch({ type: "LOGOUT" });
              //   }
              // })
              // .catch(() => {
              //   localStorage.clear();
              //   dispatch({ type: "LOGOUT" });
              // });
            }}
            block={true}
            className={'skip-Btn buttonLogOut'}
            type='primary'
            style={{ width: '100%', height: '100%', backgroundColor: 'white' }}
          >
            {/* <LogoutIcon style={{
                            color: "#F49D3F",
                        }} /> */}

            <b
              style={{ color: '#F49D3F' }}
              className={'btn-text'}
            >
              {t('profile.logout')}
            </b>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StickyTop;
